import React from 'react';
import sanitizeHtml from 'sanitize-html';
export function buildAccordionData(data = [], isRightToLeft) {
    return data.map((item) => item.content
        ? {
            title: item.title,
            children: (React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(item.content),
                } })),
            isRightToLeft,
        }
        : null);
}
